import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedserviceService } from 'src/app/services/sharedservice.service';
import {HttpParams} from '@angular/common/http';
import { first } from 'rxjs/operators';
import { parse } from 'querystring';
declare var $:any;


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  showReadMore:boolean=false;
  showReadMore2:boolean=false;
  showReadMore3:boolean=false;
  checked = false;
  
  search_list:any;
  CityList:any;
  airline_list:any;
  searchForm:FormGroup;
  filterForm:FormGroup;
  Adult:any="Adult (12+ years)";
  Infant:any="Infant (Below 2 years)";
  Airline:any="Filter By Airline";
  Travellers:any="No. of Travellers";
  sortby:any="Sort By";
  stops:any="No. of Stops";
  arrival:any="Arrival";
  departure:any="Departure";
  temp:any;
  date: Date;
  day:any;
  constructor(private activatedRoute: ActivatedRoute, private fb: FormBuilder, public httpClient: SharedserviceService, public router: Router) {
    //this.id = this.activatedRoute.snapshot.paramMap.get("id");
    //this.client_id = this.activatedRoute.snapshot.paramMap.get("id");
    //this.user.jwt="eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjo1LCJ1c2VyX2VtYWlsIjoidGVzdDJAZ21haWwuY29tIiwidHlwZSI6ImN1c3RvbWVycyJ9.krOysYurlj4bu4swegrU92AzmuIAmE0cRhvAyJ-YqNw";
  
  }
  processForm(){}
  ngOnInit() {
    $("#owl-demo2").owlCarousel({
      items: 1,
      lazyLoad: false,
      autoPlay: true,
      navigation: false,
      navigationText: false,
      pagination: true,
  });
    

    

  }

  

  

  

 

 
  
  

}
